/**
 * RuleFlowNode's own 8px mini-shell, as a raw className fragment (R4-P2
 * build brief §2.4 + §6.1 [AMENDED a9], dossier §0). `Surface.tsx` locks
 * `12px` as the ONLY house radius (no `radius` prop exists — R4-P2
 * correctness review Finding 4) and documents the split itself:
 * "Q1 LOCKED: 12px is the only house value. RuleFlowNode owns its own 8px
 * shell" — an 8px card is a genuine capability gap in `Surface`, not a
 * data-attribute one, so RuleFlowNode cannot reuse `<Surface>` by nesting
 * it (unlike MockCard/ScheduleGrid, whose flat-12px recipe DOES match
 * Surface exactly and so nest the real component instead of duplicating
 * it — see PhoneShell/MockChart for the sanctioned nesting pattern).
 * Values are copied 1:1 from the locked token table, not from Surface's
 * implementation.
 */
import { DARK_SURFACE } from './dark-tokens';

// R6 integration follow-up (2026-07-17, live-measured founder census): the
// mini-shell fill was still the pre-retint #121418, painting cool-blue
// inside the warm #120F0C figure panels across all 13 consumers (RuleFlowNode
// + everything that composes it). Sourced from the registry, not a raw hex
// — this ONE recipe module owns the fix for every consumer at once.
export const MOCK_SURFACE_MINI = `rounded-lg border border-[#FFFFFF1A] ${DARK_SURFACE.base.bg} shadow-none`;
